import React from 'react';
import './Nav.css'; // NavLogo

export var NavLogo = function NavLogo(_ref) {
  var url = _ref.url;
  return React.createElement("div", {
    className: "NavLogo"
  }, React.createElement("img", {
    src: url,
    alt: "logo"
  }));
};
// NavBottom
export var NavBottom = function NavBottom(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "NavBottom"
  }, children);
};
// NavContent
export var NavContent = function NavContent(_ref3) {
  var open = _ref3.open,
      children = _ref3.children;
  return React.createElement("div", {
    className: "NavContent ".concat(open ? 'open' : '')
  }, children);
};
NavContent.defaultProps = {
  open: false
}; // Nav

var Nav = function Nav(props) {
  return React.createElement("nav", Object.assign({
    className: "Nav"
  }, props), props.children);
};

export default Nav;